
export default {
  name: "PolaroidPhoto",
  props: {
    img: String,
    turn: String
  }
}
